import { ColumnDef, QueryResult } from "../../hooks/useQueryExec";

export interface Equipment {
  SourceTableName: string;
  RowVersion: any;
  Description: string;
  Area: string;
  Department: string;
  Criticality: string;
  Class: string;
  Service: any;
  AllowWorkOrder: number;
  PeriodsToKeepHistory: number;
  PeriodsToKeepCosts: number;
  Iso9numbernumbernumber: any;
  MechanicalIntegrity: any;
  MonthlyCostStandard: number;
  ProductionUom: any;
  CostPerLostUnit: number;
  SerialIdInstalled: string;
  SerialTracking: boolean;
  MarkedAsDeleted: boolean;
  Specifications: any;
  Account: any;
  StoresLocation: any;
  CbmZone: any;
  ManufacturerSerialId: any;
  LastModified: string;
  SiteFlag: boolean;
  LocationType: string;
  LocationStatus: any;
  SiteSparesHoldingEquip: any;
  SiteAccountingCrossref: any;
  SiteEmailAddress: any;
  LocationStatusLastChanged: string;
  TagId: any;
  EventNotifyEmailAddress: any;
  District: any;
  DateExtracted: string;
  LastCalibrated: string;
  CalibrationExpiresDate: string;
  TestEquipmentFlag: boolean;
  Purchase: any;
  Serial: any;
  Costs: any;
  UserValues: any;
  Meter: any;
  Inspections: any;
  Hierarchy: any;
  LocStatCosts: any;
  Plant: string;
  Equipment: string;
}

export interface EquipmentHierarchyType {
  childwosList: any;
  DataList: {
    text: any;
    description: any;
    iconCls: any;
    cls: any;
    expanded: boolean;
    type: any;
    children: any;
    ParentId: any;
    PartId: any;
    Part: any;
    PartType: number;
    QuantityUsed: number;
    ParentType: number;
    OrderInLevel: number;
  };
  EqpHierarchyList: any;
  list: any;
  eqpList?: EquipmentHierarchyChildType[];
  parentEquipment: any;
  syEqClassList: any;
  eqpLocationList: any;
  serialList: any;
  PathToHierarchy: any;
  SecureByHierarchyFlag: boolean;
  HierarchyValues: any;
  MessageList: any;
  Success: boolean;
}

export interface EquipmentHierarchyChildType {
  ParentDescription: string;
  PartDescription: string;
  LevelNumber: number;
  SourceTableName: string;
  RowVersion: any;
  Part: string;
  PartType: number;
  PartUsage: any;
  QuantityUsed: number;
  Uom: any;
  ObjectId: string;
  Plant: string;
  Parent: string;
  ParentType: number;
  OrderInLevel: number;
}

export type SelectedEquip = {
  id: string;
  row: QueryResult;
  columns: ColumnDef[];
};

/**
 * Part types used throughout the equipment hierarchy.
 * Mirrors AssetPoint.TabWare.Business.HierarchyPartType.
 */
export const HierarchyPartType = {
  Equipment: 1,
  Serial: 2,
  Catalog: 3,
  Manufacturer: 4,
  Item: 5,
} as const;

/**
 * A single hierarchy node as returned by EquipmentHierarchys/GetHierarchy.
 * Mirrors Services.HttpServices.Models.Equipment.DataNode — the properties
 * carrying a [JsonProperty] attribute serialise lower-cased, the rest stay
 * PascalCase.
 */
export interface HierarchyDataNode {
  Part: string;
  PartType: number;
  Description?: string;
  PartUsage?: string;
  Uom?: string;
  QuantityUsed: number;
  Parent?: string;
  ParentType: number;
  OrderInLevel: number;
  ChildrenExists: boolean;
  iconCls?: string;
  leaf?: boolean;
  expanded?: boolean;
  children?: HierarchyDataNode[];
}

export interface HierarchyActionResultType {
  RootNode?: HierarchyDataNode;
  LevelNodes?: HierarchyDataNode[];
  IsEquipmentDeleted: boolean;
  MessageList?: { Text: string }[];
  Success: boolean;
}
